export interface LegalEntity {
  id: number;
  code: number;
  company: string;
  business_name: string;
  rfc: string;
  is_commercial: boolean;
}

export interface LegalEntitiesResponse {
  data: LegalEntity[];
  meta?: { pagination?: { next_page?: number | null } };
}

export function legalEntityId(value: unknown): number | null {
  const raw = value && typeof value === 'object' ? (value as { id?: unknown }).id : value;
  if ((typeof raw !== 'number' && typeof raw !== 'string') || String(raw).trim() === '') return null;
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
}

export function legalEntityReference(value: unknown): { id: number } | null {
  const id = legalEntityId(value);
  return id === null ? null : { id };
}
